import { useContext, useEffect } from 'react';
import usePageType from '../../../Hooks/use-page-type';
import { bookingState } from '../client-state/booking-state-context';
import Newsletter from '../../../ui-components/Newsletter';
import useLocale from '../../../Hooks/use-locale';
import useLocalize from '../../../Hooks/useLocalize';
import { termsReducerActionTypes } from '../../../redusers/terms-reducer';
import useBookingShop from '../server-data/use-booking-shop';
import useBookingMinimalShop from '../server-data/use-booking-minimal-shop';
import useBookingTracking from 'Hooks/useBookingTracking';

const PRE_SELECT_PAGE_TYPES = ['booking', 'edit-booking'];

interface NewsletterWithDataProps {
  textColor?: string;
}

const NewsletterWithData = (props: NewsletterWithDataProps) => {
  const { data: minimalShop } = useBookingMinimalShop();
  const { data: shop } = useBookingShop();
  const { state, dispatch } = useContext(bookingState);
  const pageType = usePageType();
  const { languageAsEnum } = useLocale();
  const localize = useLocalize();
  const track = useBookingTracking();

  useEffect(() => {
    if (
      minimalShop?.id &&
      minimalShop.mailchimp &&
      state.terms.newsletterSubscribed === null &&
      shop?.configuration?.preSelectNewsletter &&
      PRE_SELECT_PAGE_TYPES.includes(pageType)
    ) {
      console.log('dispatch newsletter subscribed', true);
      dispatch({
        type: termsReducerActionTypes.UPDATE_NEWSLETTER_SUBSCRIBED,
        payload: true,
      });
      track({ type: 'NEWSLETTER_PRE_SELECTION', subscribed: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shop]);

  useEffect(() => {
    if (
      minimalShop?.id &&
      !minimalShop.mailchimp &&
      state.terms.newsletterSubscribed === null
    ) {
      console.log('dispatch newsletter subscribed', false);
      dispatch({
        type: termsReducerActionTypes.UPDATE_NEWSLETTER_SUBSCRIBED,
        payload: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minimalShop]);

  if (!minimalShop?.mailchimp) {
    return null;
  }

  return (
    <Newsletter
      subscribed={state.terms.newsletterSubscribed}
      text={
        shop?.bookingLocalizations?.newsletterText?.[languageAsEnum] ||
        localize('product.subscribeToNewsletter')
      }
      onChange={(subscribed) => {
        dispatch({
          type: termsReducerActionTypes.UPDATE_NEWSLETTER_SUBSCRIBED,
          payload: subscribed,
        });

        track({ type: 'CHANGE_NEWSLETTER', subscribed });
      }}
      error={Boolean(state.errors.newsletter)}
      textColor={props.textColor}
    />
  );
};

export default NewsletterWithData;
